import { createAction } from "redux-actions";
import { CREATE_TRANSFER_CORE, FIND_TRANSFER_CORE } from "../constants";
import { feathersCreateData } from "../services";
import { serverFindData } from "../services/crud";

export const internalTransferRequest = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'PROCESS INTERNAL TRANSFERS',
    data
})())

export const ownTransferRequest = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'PROCESS OWN TRANSFERS',
    data
})())

export const externalTransferRequest = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'PROCESS EXTERNAL TRANSFERS',
    data
})())

export const creditCardPayment = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'PROCESS CREDIT CARD PAYMENT',
    data
})())

export const findTransferCore = createAction(FIND_TRANSFER_CORE, (filter) => serverFindData('transfers-core', filter)())

export const findTransferCore2 = createAction(FIND_TRANSFER_CORE, (filter) => serverFindData('transfers-qr', filter)())
